import React from 'react';
import img1 from '../../../assets/frontendassets/SEO/1.png';
import img2 from '../../../assets/frontendassets/SEO/2.png';
import img3 from '../../../assets/frontendassets/SEO/3.png';
import { Col, Divider, Row } from 'antd';
import Title from 'antd/es/typography/Title';
import Paragraph from 'antd/es/typography/Paragraph';


const WebsiteSeo = () => (
  <>
      <div className='bg-[#FFF8EC] lg:pl-12 lg:pr-12  md:pl-8 md:pr-8 pl-3 pr-3 pt-8'>
      <div className="">
      <div className=''>
        {/* Intro Section */}
           <Row align={"middle"} className=" mb-[12px]   md:justify-start bg-[#FFF8EC]">
               {/* Left Column for the Divider */}
               <Col
                 xs={7}
                 sm={7}
                 md={4}
                 lg={3}
                 xl={3}
                 xxl={3}
                 className="flex justify-center items-center md:justify-start  md:mb-0 "
               >
                 <hr className="w-24 md:w-48 border-black h-0.5 bg-black pr-3" />
               </Col>
       
               {/* Right Column for the Heading */}
               <Col xs={17} sm={17} md={20} lg={20} xl={20} xxl={21} className='pl-3'>
                 <h1
                   className="text-xl sm:text-[20px] md:text-[20px] lg:text-[20px] tracking-wide text-left sm:text-left  "
                   style={{ fontFamily: '"Manrope", sans-serif' }}
                 >
                  WEBSITE + SEO IN MINUTES
                 </h1>
               </Col>
             </Row>

        {/* Main Content Section */}
  
      </div>
    </div>
    <Row
          gutter={[16, 16]}
          align="top"
          justify="center"
          className="pt-0  pb-6"
        >
          {/* Left Section */}
          <Col xs={24} md={24} lg={12} >
            <p
              className="text-left text-black text-[30px] w-[90%]"
              style={{ fontFamily: '"Manrope", sans-serif' }}
            >
            Get your Business Website with SEO in just 5 minutes
            </p>
          </Col>

          {/* Right Section */}
          <Col xs={24} md={24} lg={12}>
            <p
              className="text-left text-black text-[22px]  "
              style={{ fontFamily: '"Manrope", sans-serif' }}
            >
              With Net4Surge easily connect all aspects of your online content
              through a beautifully created website.
            </p>
          </Col>  
        </Row>
        <div className="flex flex-col  items-center text-center ">
  <div className="flex flex-col xxs:p-3 xs:p-3 md:flex-row md:justify-center flex-wrap gap-10 md:gap-14 bg-[#F6EFE3] w-full pt-10 pb-10">
    {/* Card 1 */}
    <div
      className="bg-[#F9B138] shadow-lg flex flex-col justify-between items-center rounded-lg relative w-full sm:w-[15rem] md:w-[18rem] lg:w-[20rem] h-auto py-8 mt-5 sm:mt-0"
    >
      <div className="absolute top-[-62px] rounded-full p-3">
        <img
          src={img1}
          alt="Website of your own"
          className="h-[5rem] w-[5rem] md:h-[6rem] md:w-[6rem] object-cover rounded-full"
        />
      </div>
      <p
        className="text-black tracking-wider text-base sm:text-lg md:text-xl lg:text-2xl text-center mt-8"
        style={{ fontFamily: '"Roboto", sans-serif', fontWeight: 400 }}
      >
        Website of your own
      </p>
      <p
        className="text-black text-center text-sm sm:text-base md:text-lg mt-2 px-4 mb-4 "
        style={{ fontFamily: '"Roboto", sans-serif' }}
      >
        Get the perfect online home for your courses, digital products, webinars on onboarding.
      </p>
    </div>

    {/* Card 2 */}
    <div
      className="bg-[#F9B138] shadow-lg flex flex-col justify-between items-center rounded-lg relative w-full sm:w-[15rem] md:w-[18rem] lg:w-[20rem] h-auto py-8 mt-5 sm:mt-0"
    >
      <div className="absolute top-[-62px] rounded-full p-3">
        <img
          src={img2}
          alt="Customise based on your brand"
          className="h-[5rem] w-[5rem] md:h-[6rem] md:w-[6rem] object-cover rounded-full"
        />
      </div>
      <p
        className="text-black tracking-wider text-base sm:text-lg md:text-xl lg:text-2xl text-center mt-8"
        style={{ fontFamily: '"Roboto", sans-serif', fontWeight: 400 }}
      >
        Customise based on your brand
      </p>
      <p
        className="text-black text-center text-sm sm:text-base md:text-lg mt-3 px-4"
        style={{ fontFamily: '"Roboto", sans-serif' }}
      >
        Personalize your website without any technical or design skills with our no-code editor.
      </p>
    </div>

    {/* Card 3 */}
    <div
      className="bg-[#F9B138] shadow-lg flex flex-col justify-between items-center rounded-lg relative w-full sm:w-[15rem] md:w-[18rem] lg:w-[20rem] h-auto py-8 mt-5 sm:mt-0"
    >
      <div className="absolute top-[-62px] rounded-full p-3">
        <img
          src={img3}
          alt="Your online digital store"
          className="h-[5rem] w-[5rem] md:h-[6rem] md:w-[6rem] object-cover rounded-full"
        />
      </div>
      <p
        className="text-black tracking-wider text-base sm:text-lg md:text-xl lg:text-2xl text-center mt-8"
        style={{
          fontFamily: '"Roboto", sans-serif',
          fontWeight: 400,
        }}
      >
        Your online digital store
      </p>
      <p
        className="text-black text-center text-sm sm:text-base md:text-lg mt-3 px-4 mb-3"
        style={{ fontFamily: '"Roboto", sans-serif' }}
      >
        Focus on content, while we consolidate your online business under one website.
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </p>
    </div>
  </div>
</div>

        </div>



  </>
);

export default WebsiteSeo;
